import React from 'react'

import { Form, Col } from '_zari/core'

const MonedaFormGroup = ({ value }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='input-moneda' md={4} />
      <Col md={8}>
        <Form.InputText value={value} disabled id='input-moneda' />
      </Col>
    </Form.Group>
  )
}

export default MonedaFormGroup
